
//
// This module contains all methods that handle communication between
// the React/Redux application and the JSAPI map
//

import { loadModules } from 'esri-loader';

//***************
// Map
//***************

export function setMapExtent(extent) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Map/set-extent', extent, resolve, reject);
    });
  });
}

export function getMapExtent() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Map/get-extent', resolve, reject);
    });
  });
}

export function getMapScreenshot() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Map/get-map-screenshot', resolve, reject);
    });
  });
}

export function getCurrentBasemap() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Map/get-current-basemap', resolve, reject);
    });
  });
}


export function onMapExtentChanged(cb) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Map/extent-changed', cb, resolve, reject);
    });
  });
}

export function setMapViewTarget(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Map/set-map-view-target', args, resolve, reject);
    });
  });
}

//
export function zoomToPolygon(poly) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Map/zoom-to-polygon', poly, resolve, reject);
    });
  });
}
export function setViewPopupEnabled(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Map/set-view-popup', args, resolve, reject);
    });
  });
}

export function getScreenshot(name) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Map/get-screenshot', name, resolve, reject);
    });
  });
}

export function setExtent(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Map/set-extent', args, resolve, reject);
    });
  });
}


//***************
// LayerManager
//***************

export function setOriginLayerVisible(visible) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-origin-visible', visible, resolve, reject);
    });
  });
}

export function refreshOriginLayer() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/origin-refresh', resolve, reject);
    });
  });
}

export function getOriginLayerFieldInfos() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/get-origin-fields', resolve, reject);
    });
  });
}

export function getOriginLayerDefinitionExpression() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/get-origin-definition-expression', resolve, reject);
    });
  });
}

export function setCustomFilterDefinitionExpression(expression) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-custom-filter-definition-expression', expression, resolve, reject);
    });
  });
}

export function setOriginLayerDefinitionExpression(filter) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-origin-definition-expression', filter, resolve, reject);
    });
  });
}

export function onOriginLayerUpdateEnd(cb) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/on-update-end-origin-layer', cb, resolve, reject);
    });
  });
}

export function getOriginLayerFeature(id) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/get-origin-feature', id, resolve, reject);
    });
  });
}

export function isOriginWithinPerimeter(perimeter, x, y) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/is-origin-within-perimeter', perimeter, x, y, resolve, reject);
    });
  });
}

export function getOriginLayerFeatures(geometry) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/get-origin-features', geometry, resolve, reject);
    });
  });
}

export function setSpatialFilterPolygon(polygon) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-spatial-filter-polygon', polygon, resolve, reject);
    });
  });
}

export function getFullOriginLayerFeaturesFromApi(ids) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/get-full-origin-features-from-api', ids, resolve, reject);
    });
  });
}


export function setOriginSelectionGraphic(point) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-origin-selection-graphic', point, resolve, reject);
    });
  });
}


export function setOriginSelectionGraphics(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-origin-selection-graphics', args, resolve, reject);
    });
  });
}

export function queryIntersectingIncidents(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/query-intersecting-incidents', args, resolve, reject);
    });
  });
}

export function clearOriginSelectionGraphics(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/clear-origin-selection-graphics', args, resolve, reject);
    });
  });
}

export function setVisiblePerimeters(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-visible-perimeters', args, resolve, reject);
    });
  });
}

export function setPerimeterGraphic(perimeter) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-perimeter-graphic', perimeter, resolve, reject);
    });
  });
}

export function getForIdsForQuery(spatialFilterId, geometry, resultOffset, results, whereClause) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/get-forids-for-query', spatialFilterId, geometry, resultOffset, results, whereClause, resolve, reject);
    });
  });
}

export function clearPerimeterGraphics() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/clear-perimeter-graphics', resolve, reject);
    });
  });
}


export function clearVisiblePerimeters(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/clear-visible-perimeters', args, resolve, reject);
    });
  });
}

export function setPerimeterSymbology(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-perimeters-symbology', args, resolve, reject);
    });
  });
}

export function setModifiedPerimeter(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-modified-perimeter', args, resolve, reject);
    });
  });
}

export function setModifiedPerimeterNoClear(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/set-modified-perimeter-no-clear', args, resolve, reject);
    });
  });
}

export function addDebugGraphic(graphic, attributes, isConflict) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/add-debug-graphic', graphic, attributes, isConflict, resolve, reject);
    });
  });
}

export function clearModifiedPerimeter(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('LayerManager/clear-modified-perimeter', args, resolve, reject);
    });
  });
}

//***************
// DrawToolbar
//***************

export function enableDrawMode(args) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Draw/enable-draw-mode', args, resolve);
    });
  });
}

export function disableDrawMode() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Draw/disable-draw-mode', resolve);
    });
  });
}

export function pauseDrawMode() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Draw/pause-draw-mode', resolve);
    });
  });
}

export function resumeDrawMode() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Draw/resume-draw-mode', resolve);
    });
  });
}

export function onDrawGeometryUpdated(callback) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Draw/set-on-geometry-update-callback', callback, resolve, reject);
    });
  });
}

export function completeDrawUpdate() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Draw/complete-update', resolve, reject);
    });
  });
}

export function setUploadPolygonGeometry(geometry) {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Draw/set-upload-polygon-geometry', geometry, resolve, reject);
    });
  });
}

export function getDrawPolygonGeometry() {
  return new Promise((resolve, reject) => {
    loadModules(['dojo/topic']).then( ([topic]) => {
      topic.publish('Draw/get-polygon-geometry', resolve, reject);
    });
  });
}
